export default __webpack_public_path__ + "static/media/openshift.f29e2361.svg";